module.exports = __webpack_public_path__ + "media/images/undraw/emails-598ddd08c1b8404ff7b278528be630a3.png";